/**
 * [data-fade-in] 要素を、 viewport の 2/3 位置に達した時点で表示する。
 *
 * - 要素 top が viewport 上端から 67% の位置 (= viewport の上 2/3 ライン) を
 *   下から上に越えた瞬間にトリガー
 *   → IntersectionObserver の rootMargin: '0px 0px -33% 0px' で
 *     viewport の下 33% を除外することで実現
 * - 一度表示したら data-fade-visible を付けたまま unobserve、 戻りスクロールでも常時表示
 *
 * 演出 (opacity / translate / blur) は assets/tailwind.css の
 * `[data-fade-step], [data-fade-in]` セレクタを参照。
 */
(function () {
  'use strict';

  function init() {
    var els = document.querySelectorAll('[data-fade-in]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      /* IntersectionObserver 非対応環境 (古いブラウザ) では即時表示 */
      els.forEach(function (el) { el.setAttribute('data-fade-visible', ''); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-fade-visible', '');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -33% 0px',
      threshold: 0,
    });

    els.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
